import Img1 from "../assets/images/news1.png";
import Img2 from "../assets/images/news2.png";
import Img3 from "../assets/images/news3.png";
import Img4 from "../assets/images/news4.png";
export const topRated = [
  {
    name: "BritishSpring School",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 1,
  },
  {
    name: "ST Grigs Academy",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys ",
    category: "Primary and Secondary",
    operation: "Day and Boarding",
    id: 1,
  },
  {
    name: "Bereton School.",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Boarding",
    id: 1,
  },
];
export const featuredSchs = [
  {
    name: "BritishSpring School",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Primary",
    operation: " Boarding",
    id: 1,
  },
  {
    name: "ST Grigs Academy",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys ",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 2,
  },
  {
    name: "Bereton School.",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 3,
  },
  {
    name: "Bereton School.",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 4,
  },
  {
    name: "Bereton School.",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 5,
  },
  {
    name: "Bereton School.",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 6,
  },
  {
    name: "Bereton School.",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 7,
  },
  {
    name: "Bereton School.",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 8,
  },
  {
    name: "Bereton School.",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 9,
  },
  {
    name: "Bereton School.",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 10,
  },
  {
    name: "Bereton School.",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 11,
  },
  {
    name: "Bereton School.",
    address: "1, British Spring Estate Road, Nkwelle Awka, Anambra State.",
    phone1: "+2347032861442",
    phone2: " +2347032861442",
    gender: "Boys and Girls",
    category: "Junior and Secondary",
    operation: "Day and Boarding",
    id: 12,
  },
];
